import React, { useMemo } from 'react'
import WhiteHatSentinelMappingForm from './WhiteHatSentinelMappingForm';
import WhiteHatSentinelCredentialsForm from './WhiteHatSentinelCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { Typography } from 'antd';
import { CellRenderers } from 'utils/tableUtils';

function renderLink(name, record, assetType, toolName){
    if(!name){
        return CellRenderers.VALUE_OR_NA();
    }
    return (
        <Typography.Link
            href={`/user/tools/generic/project/${toolName}/redirect?login_id=${
                record.login_id
            }&name=${record[assetType + "Id"]}&assetType=${assetType}`}
            target='_blank'
        >
            {name}
        </Typography.Link>
    );
}

export default function WhiteHatSentinelConfigListing(props) {


    const columns = useMemo(() => [
        {
            title: "Application",
            dataIndex: "applicationName",
            width: 120,
            render: (name, record) => renderLink(name, record, "application", props.name)
        }, {
            title: "Site",
            dataIndex: "siteName",
            width: 120,
            render: (name, record) => renderLink(name, record, "site", props.name)
        }
    ], [props.name]);

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={WhiteHatSentinelMappingForm}
            CredentialsForm={WhiteHatSentinelCredentialsForm}
            extraColumns={columns}
        />
    )
}